<template>
	<div class="login-container">
		<div class="loginPageHeader">
			<div class="loginPageLogo pt-25 text-center">
				<img src="@/assets/risolto_logo_full.png" height="30" />
			</div>
			<div style="position: fixed;right: 30px;top: 25px;">
				<lang-select></lang-select>
			</div>
		</div>
		<el-row>
			<el-col :span="24">
				<h1 class="loginWelcomeHeader">{{ $t('loginWelcomeHeader') }}</h1>
			</el-col>
		</el-row>
		<el-row :gutter="40">
			<!-- <el-col :span="7" :offset="5">
				<el-card style="min-height: 150px; position: relative">
					<p>{{ $t('recipientLoginDescription') }}</p>
					<div style="position: absolute; bottom: 0; height: 80px">
						<el-button size="small" class="mt-20" @click="handleCognitoLoginRecipient">
							{{ $t('loginAsRecipient') }}
						</el-button>
					</div>
				</el-card>
			</el-col> -->
			<el-col :span="24">
				<div class="w-100 text-center">
					<!-- <el-card style="min-height: 150px; position: relative"> -->
					<!-- <p>{{ $t('participantLoginDescription') }}</p> -->
					<!-- <div style="position: absolute; bottom: 0; height: 80px"> -->
					<el-button size="small" class="mt-20" @click="handleCognitoLoginParticipant">
						{{ $t('loginAsParticipant') }}
					</el-button>
				</div>
				<!-- <el-button size="small" class="mt-20" @click="handleCognitoLoginParticipant">
							{{ $t('registerAsParticipant') }}
						</el-button> -->
				<!-- </div> -->
				<!-- </el-card> -->
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { validUsername } from '@/utils/validate';
import cognito from '@/cognito';
import LangSelect from '@/components/LangSelect';

export default {
	name: 'Login',
	components: {
		LangSelect
	},
	data() {
		const validateUsername = (rule, value, callback) => {
			if (!validUsername(value)) {
				callback(new Error('Please enter the correct user name'));
			} else {
				callback();
			}
		};
		const validatePassword = (rule, value, callback) => {
			if (value.length < 6) {
				callback(new Error('The password can not be less than 6 digits'));
			} else {
				callback();
			}
		};
		return {
			loginForm: {
				username: 'admin',
				password: '111111'
			},
			loginRules: {
				username: [{ required: true, trigger: 'blur', validator: validateUsername }],
				password: [{ required: true, trigger: 'blur', validator: validatePassword }]
			},
			passwordType: 'password',
			capsTooltip: false,
			loading: false,
			showDialog: false,
			redirect: undefined,
			otherQuery: {}
		};
	},
	watch: {
		$route: {
			handler: function(route) {
				const query = route.query;
				if (query) {
					this.redirect = query.redirect;
					this.otherQuery = this.getOtherQuery(query);
				}
			},
			immediate: true
		}
	},

	mounted() {
		if (this.loginForm.username === '') {
			this.$refs.username.focus();
		} else if (this.loginForm.password === '') {
			this.$refs.password.focus();
		}
	},
	created() {},
	methods: {
		handleCognitoLoginParticipant() {
			cognito.login();
		},
		checkCapslock({ shiftKey, key } = {}) {
			if (key && key.length === 1) {
				if ((shiftKey && (key >= 'a' && key <= 'z')) || (!shiftKey && (key >= 'A' && key <= 'Z'))) {
					this.capsTooltip = true;
				} else {
					this.capsTooltip = false;
				}
			}
			if (key === 'CapsLock' && this.capsTooltip === true) {
				this.capsTooltip = false;
			}
		},
		showPwd() {
			if (this.passwordType === 'password') {
				this.passwordType = '';
			} else {
				this.passwordType = 'password';
			}
			this.$nextTick(() => {
				this.$refs.password.focus();
			});
		},
		// handleLogin() {
		// 	this.$refs.loginForm.validate(valid => {
		// 		if (valid) {
		// 			this.loading = true;
		// 			this.$store.dispatch('user/login', this.loginForm)
		// 				.then(() => {
		// 					this.$router.push({ path: this.redirect || '/', query: this.otherQuery });
		// 					this.loading = false;
		// 				})
		// 				.catch(() => {
		// 					this.loading = false;
		// 				});
		// 		} else {
		// 			console.log('error submit!!');
		// 			return false;
		// 		}
		// 	});
		// },
		getOtherQuery(query) {
			return Object.keys(query).reduce((acc, cur) => {
				if (cur !== 'redirect') {
					acc[cur] = query[cur];
				}
				return acc;
			}, {});
		}
		// afterQRScan() {
		//   if (e.key === 'x-admin-oauth-code') {
		//     const code = getQueryObject(e.newValue)
		//     const codeMap = {
		//       wechat: 'code',
		//       tencent: 'code'
		//     }
		//     const type = codeMap[this.auth_type]
		//     const codeName = code[type]
		//     if (codeName) {
		//       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
		//         this.$router.push({ path: this.redirect || '/' })
		//       })
		//     } else {
		//       alert('第三方登录失败')
		//     }
		//   }
		// }
	}
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
	.login-container .el-input input {
		color: $cursor;
	}
}

/* reset element-ui css */
.login-container {
	height: 100vh !important;
	.el-input {
		display: inline-block;
		height: 47px;
		width: 85%;

		input {
			background: transparent;
			border: 0px;
			-webkit-appearance: none;
			border-radius: 0px;
			padding: 12px 5px 12px 15px;
			color: $light_gray;
			height: 47px;
			caret-color: $cursor;

			&:-webkit-autofill {
				box-shadow: 0 0 0px 1000px $bg inset !important;
				-webkit-text-fill-color: $cursor !important;
			}
		}
	}

	.el-form-item {
		border: 1px solid rgba(255, 255, 255, 0.1);
		background: rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		color: #454545;
	}
}
</style>

<style lang="scss" scoped>
$bg: #f8ab10;
$dark_gray: #889aa4;
$light_gray: #eee;

.loginWelcomeHeader {
	text-align: center;
	padding: 50px 0 50px 0;
	color: #ffffff !important;
}

.login-container {
	min-height: 100%;
	width: 100%;
	background-color: $bg;
	overflow: hidden;

	.login-form {
		position: relative;
		width: 520px;
		max-width: 100%;
		padding: 160px 35px 0;
		margin: 0 auto;
		overflow: hidden;
	}

	.tips {
		font-size: 14px;
		color: #fff;
		margin-bottom: 10px;

		span {
			&:first-of-type {
				margin-right: 16px;
			}
		}
	}

	.svg-container {
		padding: 6px 5px 6px 15px;
		color: $dark_gray;
		vertical-align: middle;
		width: 30px;
		display: inline-block;
	}

	.title-container {
		position: relative;

		.title {
			font-size: 26px;
			color: $light_gray;
			margin: 0px auto 40px auto;
			text-align: center;
			font-weight: bold;
		}
	}

	.show-pwd {
		position: absolute;
		right: 10px;
		top: 7px;
		font-size: 16px;
		color: $dark_gray;
		cursor: pointer;
		user-select: none;
	}

	.thirdparty-button {
		position: absolute;
		right: 0;
		bottom: 6px;
	}

	@media only screen and (max-width: 470px) {
		.thirdparty-button {
			display: none;
		}
	}

	.loginPageHeader {
		width: 100%;
		height: 80px;
		background: white;
	}
}
</style>
